import Struct, { placeholder } from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "../control/index.js";
import { ScrcpyBackOrScreenOnControlMessage1_16, ScrcpyOptions1_16, } from "./1_16/options.js";
export const ScrcpyBackOrScreenOnControlMessage1_18 = new Struct()
    .fields(ScrcpyBackOrScreenOnControlMessage1_16)
    .uint8("action", placeholder());
export class ScrcpyOptions1_18 extends ScrcpyOptions1_16 {
    constructor(value) {
        super(value);
    }
    getArgumentOrder() {
        return super.getArgumentOrder().concat(["powerOffOnClose"]);
    }
    getDefaultValue() {
        return {
            ...super.getDefaultValue(),
            powerOffOnClose: false,
        };
    }
    getOutputEncoderNameRegex() {
        return /\s+scrcpy --encoder '(.*?)'/;
    }
    getControlMessageTypes() {
        /**
         *  0 InjectKeycode
         *  1 InjectText
         *  2 InjectTouch
         *  3 InjectScroll
         *  4 BackOrScreenOn
         *  5 ExpandNotificationPanel
         *  6 ExpandSettingsPanel
         *  7 CollapseNotificationPanel
         *  8 GetClipboard
         *  9 SetClipboard
         * 10 SetScreenPowerMode
         * 11 RotateDevice
         */
        const types = super.getControlMessageTypes();
        types.splice(6, 0, ScrcpyControlMessageType.ExpandSettingPanel);
        return types;
    }
    serializeBackOrScreenOnControlMessage(message) {
        return ScrcpyBackOrScreenOnControlMessage1_18.serialize(message);
    }
}
//# sourceMappingURL=1_18.js.map